import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common'

@Pipe({
  name: 'filtroFecha'
})
export class FiltroFechaPipe implements PipeTransform {

  transform(value: any[], propiedad:string, fecha1:string, fecha2:string): any[] {
    let newArr=[]
    let dpipe = new DatePipe("en-US")
    for(let i of value){
      if(new Date(dpipe.transform(i[propiedad], "yyyy-MM-dd")) >= new Date(dpipe.transform(fecha1, "yyyy-MM-dd")) && 
      new Date(dpipe.transform(i[propiedad], "yyyy-MM-dd")) <= new Date(dpipe.transform(fecha2, "yyyy-MM-dd"))){
        newArr.push(i)
      }
    }

    return newArr
  }

}
